<template>
	<div id="swiper-wrapper">
		<Row>
			<Col span="1">
			<div class="left-div" @click="prevBtn">
				<img src="../assets/img/left.png" class="carousel-left">
			</div>
			</Col>

			<Col span="22" style="margin-left: -0.15rem;padding-right: 0.24rem;">
			<div>
				<swiper ref="mySwiper" :options="swiperOption">

					<swiper-slide class="recommend-item" v-for="item of recommends" :key="item.goodsId">
						<router-link :to="{path:'minimalistSolution',query:{num:item.goodsId}}">
							<!-- <img :src=require(item.image) width="100%" height="100%"> -->
							<div style="padding-top: 0.5rem;">
								<div class="carousel-img">
									<img :src="item.image" width="100%" height="100%">
									<!-- {{item.image}} -->
									<!-- <div class="shadow"></div> -->
									<!--                   <div class="Light">
                                      <img src="../assets/img/组 8.png">
                                      </div> -->
								</div>
								<div class="carousel-bg">
									<div style="height: 4rem;"></div>
									<h3>{{item.goodsName}}</h3>
									<p>{{item.goodsContent}}</p>
								</div>
							</div>
							<!-- <img src="../assets/示例1.jpg" class="recommend-img" /> -->
						</router-link>
					</swiper-slide>
					<!--               <div class="swiper-button-prev" slot="button-prev" @click="prevBtn"></div>
                <div class="swiper-button-next" slot="button-next" @click="nextBtn"></div> -->
				</swiper>
			</div>
			</Col>

			<Col span="1">
			<div class="right-div">
				<img src="../assets/img/right.png" class="carousel-right" @click="nextBtn">
			</div>
			</Col>
		</Row>

	</div>
</template>

<script>
	import {
		Icon
	} from 'vant';
	import {
		Swiper,
		SwiperSlide
	} from 'vue-awesome-swiper'
	import 'swiper/css/swiper.css';
	export default {
		components: {
			[Icon.name]: Icon,
			Swiper,
			SwiperSlide,
		},
		props: {},
		data() {
			return {
				swiperOption: {
					slidesPerView: 3,
					autoplay: false,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}
				},
				recommends: [{
						goodsId: 0,
						image: require("../assets/img/jjytjjfa.png"),
						goodsName: "极简以太全光解决方案",
						goodsContent: "适用于高教，普教，普通医疗等"
					},
					{
						goodsId: 1,
						image: require("../assets/img/bdwlw.png"),
						goodsName: "本地化物联网平台解决方案",
						goodsContent: "适用于园区、工厂、大型社区、高校等"
					},
					{
						goodsId: 2,
						image: require("../assets/img/zhyq.png"),
						goodsName: "智慧园区解决方案",
						goodsContent: "适用于各类型园区智慧化综合管理场景"
					}
				]
			}
		},
		methods: {
			prevBtn() {
				this.$refs.mySwiper.$swiper.slidePrev();
			},
			nextBtn() {
				this.$refs.mySwiper.$swiper.slideNext();
			}
		}
	}
</script>

<style lang="less">
	.carousel-bg {
		border-radius: 0.125rem;
		background-color: #FFFFFF;
		height: 5.5rem;
		margin-right: 0.25rem;
		padding: 0 0.1rem;
		text-align: center;
		box-shadow: 0 0 5px #eaeff5 inset;
		margin-bottom: 0.1rem;
	}

	.carousel-bg h3 {
		font-size: 0.25rem;
		margin-top: 0.2rem;
		font-family: SourceHanSansCN-Regular;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0rem;
		color: #253954;
		/* letter-spacing:0.02rem; */
	}

	.carousel-bg p {
		margin-top: 0.2rem;
		font-size: 0.1rem;
		font-family: SourceHanSansCN-Light;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0rem;
		color: #9dadc1;
	}

	.carousel-left,
	.carousel-right {
		height: 0.75rem;
	}

	.left-div {
		height: 3rem;
		margin-top: 2.5rem;
	}

	.right-div {
		height: 3rem;
		margin-top: 2.5rem;
		margin-left: -0.25rem;
	}

	.carousel-img {
		float: left;
		margin-top: 0.3rem;
		width: 80%;
		top: 0px;
		margin-left: 7%;
		position: relative;
		z-index: 4;
		cursor: pointer;

		img {
			position: relative;
			z-index: 3;
		}

		.Light {
			position: absolute;
			top: 0.36rem;
			opacity: 0;
			//top: 2rem;
			left: 0.22rem;
			width: 1.455rem;
			height: 1.515rem;

			img {
				width: 100%;
				position: relative;
				z-index: 2;
			}
		}

		.shadow {
			position: absolute;
			z-index: -1;
			bottom: -0.45rem;
			left: 0.46rem;
			width: 2rem;
			border-radius: 0.1rem;
			height: 2.4rem;
			background: #eaeff5;
			transform: perspective(772px) rotateZ(64deg) rotateX(45deg) rotateY(-46deg);
		}


	}

	.recommend-item:hover {
		.carousel-img {
			top: -0.1rem;
			transition: 0.3s;

			img {
				position: relative;
				z-index: 100;
			}

			.Light {
				top: 0.36rem;
				transition: 1.5s;
				opacity: 1;
				z-index: 2;

				img {
					width: 100%;
				}
			}

			.shadow {
				bottom: -0.7rem;
				transition: 0.3s;
			}
		}

		.carousel-bg {
			transform: scale(1.05);
			transition: 0.3s;

			h3 {
				font-family: SourceHanSansCN-Regular;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 0rem;
				color: #009bff;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/util/Carousel.vue